import React, { useContext } from 'react';
import { ActionType, store } from './store';
import './header.css';

function BotAvatar() {
    const globalStore = useContext(store);

    return (
        <div className="react-chatbot-kit-chat-bot-avatar">
            <div className="react-chatbot-kit-chat-bot-avatar-container">
                <img style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50px',
                  border: '1px',
                  backgroundColor: 'white',
                }} src={globalStore.state.config.AssistantInfo?.AssistantLogo || ''} alt={globalStore.state.config.AssistantInfo?.AssistantName} />
                <div style={{
                        fontSize: '0.7rem',
                        whiteSpace: 'nowrap',
                    }}>
                    {globalStore.state.config.AssistantInfo?.AssistantName}
                </div>
                {/*<p style={{*/}
                {/*    fontSize: '1rem',*/}
                {/*}} className="react-chatbot-kit-chat-bot-avatar-letter">Mira</p>*/}
            </div>
        </div>
    )
}

export default BotAvatar;
